/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FormEventModel } from './FormEventModel';
import {
    FormEventModelFromJSON,
    FormEventModelFromJSONTyped,
    FormEventModelToJSON,
} from './FormEventModel';

/**
 * 
 * @export
 * @interface PetFormConfigurationResponseEventModel
 */
export interface PetFormConfigurationResponseEventModel {
    /**
     * 
     * @type {FormEventModel}
     * @memberof PetFormConfigurationResponseEventModel
     */
    impression?: FormEventModel;
    /**
     * 
     * @type {FormEventModel}
     * @memberof PetFormConfigurationResponseEventModel
     */
    error?: FormEventModel;
}

/**
 * Check if a given object implements the PetFormConfigurationResponseEventModel interface.
 */
export function instanceOfPetFormConfigurationResponseEventModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetFormConfigurationResponseEventModelFromJSON(json: any): PetFormConfigurationResponseEventModel {
    return PetFormConfigurationResponseEventModelFromJSONTyped(json, false);
}

export function PetFormConfigurationResponseEventModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetFormConfigurationResponseEventModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'impression': !exists(json, 'impression') ? undefined : FormEventModelFromJSON(json['impression']),
        'error': !exists(json, 'error') ? undefined : FormEventModelFromJSON(json['error']),
    };
}

export function PetFormConfigurationResponseEventModelToJSON(value?: PetFormConfigurationResponseEventModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'impression': FormEventModelToJSON(value.impression),
        'error': FormEventModelToJSON(value.error),
    };
}

